import { useMemo } from 'react';
import { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { useDefaultFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useDefaultFilterSet';

export const useResolvedFilterSet = (filterSet?: IFilterSet[]): IFilterSet[] => {
  const defaultFilterSet = useDefaultFilterSet();

  return useMemo(
    () => filterSet ?? defaultFilterSet,
    [filterSet, defaultFilterSet],
  );
};
